<template>
    <div class="job-role">
        <div class="control-width mx-auto">
            <div class="p-4 p-md-5">
                <h6 class="mb-3 font-weight-bold kova-text text-left">Select talents experience level </h6>
                <div class="text-left">
                    <label for="opt1" class="radio text-left" style="font-size: 13px">
                        <input type="radio" name="rdo" id="opt1" class="hidden" value="devone" v-model="price"/>
                        <span class="label"></span>Junior ($10 - $20/hr)
                    </label><br />
                    
                    <label for="opt2" class="radio text-left" style="font-size: 13px">
                        <input type="radio" name="rdo" id="opt2" class="hidden" value="devtwo" v-model="price" />
                        <span class="label"></span>Intermediate ($15 - $40/hr)
                    </label><br />

                    <label for="opt3" class="radio text-left" style="font-size: 13px">
                        <input type="radio" name="rdo" id="opt3" class="hidden" value="devthree" v-model="price"/>
                        <span class="label"></span> Senior ($25- $60/hr)
                    </label>
                    <!-- <div class="ml-5" v-if="showInput">
                    State it:  <input type="number" class="input" placeholder="1000"/>
                    </div> -->
                </div>
                <h6 class="my-3 font-weight-bold kova-text text-left"> Salary range </h6>
                <div class="text-left">
                    <a-input placeholder="1000" size="large" style="color: #000">
                        <a-select slot="addonAfter" default-value="US Dollar" style="width: 80px">
                        <a-select-option value="dollar">
                            US Dollar
                        </a-select-option>
                        <a-select-option value="naira">
                            Naira
                        </a-select-option>
                        <a-select-option value="euros">
                            Euros
                        </a-select-option>
                        </a-select>
                    </a-input>
                </div>
                <h6 class="my-3 font-weight-bold kova-text text-left"> How many developers are you hiring?</h6>
                <div class="text-left">
                    <span class="font-weight-bold" style="font-size: 13px">How many?<a-input-number class="ml-2" size="large" :min="0" :max="100" placeholder="0" /></span><br />
                </div>

                <h6 class="my-3 font-weight-bold kova-text text-left">Company Location</h6> 
                <a-select 
                mode="multiple" class="w-100 mt-2" size="large" placeholder="Please select your Country">
                    <a-select-option v-for="(item, index) in countries" :key="index"
                    >{{item.name}}</a-select-option>
                </a-select>   

                <div class="container-fluid px-0 px-md-4 mb-5 mt-5">
                    <div class="row">
                        <div class="col text-left">
                            <button class="btn-outline-kovatek py-2 px-4 px-sm-5 rounded" style="font-size: 13px" v-on:click="goBack"> Back </button>
                        </div>
                        <div class="col text-right">
                            <button class="btn-kovatek py-2 px-4 px-sm-5 rounded" style="font-size: 13px" @click="next"> Next </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        
 </div>
</template>
<script>

export default {
    name: 'job-role',
    components: {
        
    },
    data(){
        return {
            htmlForEditor: "",
            devSkills: [],
            skills: [
                'Android', 'IOS', 'CyberSecurity','Data Engineering', 'eCommerce', 'Web Application','Front-end',
                'Back-end', 'UI/UX', 'Artificial Intelligence', 'Blockchain', 'Integration', 'Project management',
                'DApps', 'DevOps'
            ],
            countries: [
                {name: 'United States'},
                {name: 'Canada'},
                {name: 'Nigeria'},
                {name: 'Kenya'}
            ],
            price: ''
        }
    },
    methods: {
        goBack(){
            this.$router.go(-1)
        },
        next(){
            this.$router.push({path:'signup'})
        },
       
        handleImageAdded: function(file, Editor, cursorLocation, resetUploader) {
        
            var formData = new FormData();
            formData.append("file", file);
        
            this.$http({
                url: "https://fakeapi.yoursite.com/images",
                method: "POST",
                data: formData
            })
            .then(result => {
            let url = result.data.url; // Get url from response
            Editor.insertEmbed(cursorLocation, "file", url);
            resetUploader();
            })
            // .catch(err => {
            // console.log(err);
            // });
        }
    }
}
</script>
<style scoped>

</style>
